<template>
  <v-card style="height: calc(100vh - 48px)">
    <v-card-text>
      <v-simple-table class="reupload-config-table">
        <thead>
          <tr>
            <th>Projects</th>
            <th>Reupload From</th>
            <th>Reupload To</th>
            <th>
              <v-row class="mx-0 mt-1 justify-end">
                <v-btn
                  icon
                  color="error"
                  title="Reset all"
                  :disabled="!projectGroups.length"
                  :loading="isLoading"
                  @click="projectGroups = []"
                >
                  <v-icon>
                    mdi-cancel
                  </v-icon>
                </v-btn>

                <v-btn
                  color="primary"
                  icon
                  @click="onAddProjectGroup"
                >
                  <v-icon>
                    mdi-plus
                  </v-icon>
                </v-btn>

                <v-btn
                  icon
                  color="primary"
                  :loading="isLoading"
                  :disabled="!projectGroups.length || !isValid"
                  @click="onConfirm"
                >
                  <v-icon>
                    check
                  </v-icon>
                </v-btn>
              </v-row>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="(projectGroup, projectGroupIndex) in projectGroups"
            :key="projectGroup._displayConfig.key"
          >
            <td>
              <select-project
                v-model="projectGroup.projects"
                class="mt-0 pt-0"
                label=""
                :chipCount="4"
                multiple
              />
            </td>
            <td>
              <date-picker
                v-model="projectGroup.from"
                class="mt-0 pt-0 date-picker"
                style="max-width: 290px"
              />
            </td>
            <td>
              <date-picker
                v-model="projectGroup.to"
                class="mt-0 pt-0 date-picker"
                style="max-width: 290px"
              />
            </td>
            <td>
              <v-row class="mx-0 mt-1 justify-end">
                <v-btn
                  icon
                  color="error"
                  @click="projectGroups.splice(projectGroupIndex, 1)"
                >
                  <v-icon>
                    mdi-close
                  </v-icon>
                </v-btn>
              </v-row>
            </td>
          </tr>
        </tbody>
      </v-simple-table>
    </v-card-text>
    <v-snackbar
      color="primary"
      timeout="3000"
      top
      dark
      :value="displaySuccess"
      @input="$emit('toggle-snackbar', $event)"
    >
      <div class="d-flex justify-space-between">
        <div class="d-flex flex-column justify-center">
            <span>Reupload scheduled successfully</span>
        </div>
        <v-btn
          icon
          @click="$emit('toggle-snackbar', false)"
        >
          <v-icon>
            mdi-close-circle
          </v-icon>
        </v-btn>
      </div>
    </v-snackbar>
  </v-card>
</template>

<style lang="scss" scoped>
  .date-picker::v-deep > div {
    padding-left: 0;
    padding-right: 0;
  }
  .reupload-config-table {
    tbody {
      ::v-deep {
        .v-input {
          max-width: 35rem;

          .v-input__slot::before {
            //content: none;
          }

          .v-label {
            display: none;
          }
        }
      }
    }
  }
</style>

<script>
  import SelectProject from '@/components/core/SelectProject/SelectProject.vue'
  import DatePicker from '@/components/core/DatePicker/DatePicker.vue'

  export default {
    components: {
      SelectProject,
      DatePicker
    },
    props: {
      isLoading: Boolean,
      displaySuccess: Boolean,
    },
    data () {
      return {
        projectGroups: [],
      }
    },

    computed: {
      isValid () {
        return this.projectGroups.every(group => group.projects.length && this.isValidDate(group.from) && this.isValidDate(group.to))
      }
    },

    methods: {
      onConfirm () {
        this.$root.$confirm(
          'Confirm',
          'Are you sure you want to trigger data reupload for all projects in the table?',
        )
          .then(yes => {
            if (yes) {
              this.$emit('reupload', this.projectGroupsToParams(this.projectGroups))
            }
          })
      },

      isValidDate (value) {
        return !Number.isNaN((new Date(value)).valueOf())
      },

      onAddProjectGroup () {
        this.projectGroups.push({
          projects: [],
          from: '',
          to: '',

          _displayConfig: {
            key: Date.now() * Math.random(),
          }
        })
      },

      projectGroupsToParams (projectGroups) {
        const params = []

        for (const projectGroup of projectGroups) {
          if (
            !projectGroup.from ||
            !projectGroup.to ||
            !projectGroup.projects.length
          ) {
            continue
          }

          for (const project of projectGroup.projects) {
            params.push({
              projectId: project,
              from: projectGroup.from,
              to: projectGroup.to,
            })
          }
        }

        return params
      },
    },
  }
</script>
